import { PROVIDER_ICON_CATALOG } from './provider-icon-catalog.generated';
import type { ProviderDialectId, ProviderIconCatalogEntry, ProviderShapeSpec } from './types';

const PROVIDER_ICON_ROOT = '/assets/network-icons';
const ICONS_BY_PROVIDER = new Map<ProviderDialectId, ProviderIconCatalogEntry[]>();

for (const icon of PROVIDER_ICON_CATALOG.icons) {
  const existing = ICONS_BY_PROVIDER.get(icon.provider) ?? [];
  existing.push(icon);
  ICONS_BY_PROVIDER.set(icon.provider, existing);
}

export function getProviderIconUrl(shapeSpec: ProviderShapeSpec): string | null {
  if (shapeSpec.iconUrl?.startsWith(`${PROVIDER_ICON_ROOT}/`)) return shapeSpec.iconUrl;
  return `${PROVIDER_ICON_ROOT}/${shapeSpec.dialectId}/${shapeSpec.id}.svg`;
}

export function listProviderIconCatalogEntries(provider?: ProviderDialectId): readonly ProviderIconCatalogEntry[] {
  return provider ? ICONS_BY_PROVIDER.get(provider) ?? [] : PROVIDER_ICON_CATALOG.icons;
}

export function getProviderIconCatalogGeneratedAt(): string {
  return PROVIDER_ICON_CATALOG.generatedAt;
}
